
































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { getQuestionCart, updateQuestionCart } from '../model/api'
import { sa } from '@/utils/sa'

@Component
export default class extends Vue {
  public data = [1]
  public list = []
  public clickWhere = ''
  public questions = []
  public status: boolean = false
  public showDetail(val: boolean) {
    this.status = !val
  }
  // computed
  public get cartInfo() {
    return this.$store.state.question.cart
  }
  public get count() {
    return this.cartInfo && this.cartInfo.question_ids ? this.cartInfo.question_ids.length : 0
  }
  public get user() {
    return this.$store.state.user
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  @Watch('cartInfo', { deep: true })
  onInfoChange(data) {
    if (!data) {
      return
    }
    this.processCart(data)
  }
  @Watch('user', { deep: true })
  onUserChange(val) {
    if (val && val.name) {
      this.getCart()
      if (this.clickWhere === 'preview') {
        this.goPreview()
      }
    } else {
    }
  }
  @Watch('subjectId')
  onSubjectChange(val, old) {
    if (val !== old) {
      // this.clearAll()
      this.getCart()
    }
  }
  // mounted
  public mounted() {
    // this.clearAll()
    this.getCart()
  }
  // methods
  public goPreview() {
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '试题篮',
        buttonName: '预览'
      })
    }, 50)
    if (this.user && this.user.name) {
      if (this.cartInfo && this.cartInfo.question_ids.length) {
        location.href = '/search/question/preview'
      }
    } else {
      this.clickWhere = 'preview'
      this.$store.commit('SET_LOGINMODAL', true)
    }
  }
  public processCart(msg) {
    let temp: any = []
    // for (let n in msg.classification) {
    //   temp = [
    //     ...temp,
    //     { key: n, name: msg.classification[n].type, val: msg.classification[n].sequence }
    //   ]
    // }
    temp = msg.classification
    this.list = temp
    // console.log(this.list)
    this.questions = msg.question_ids
  }
  public async getCart() {
    let temp: any = []
    let data = await getQuestionCart({ subject_id: this.subjectId })
    if (data.success) {
      this.$store.commit('SET_CART', data.msg)
      // console.log(data.msg)
      this.processCart(data.msg)
    } else {
      if (data.error === '请登录') {
        this.$store.commit('SET_CART', { classification: {}, question_ids: [], title: '' })
      }
    }
  }
  public async clearAll(item?) {
    let params = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subjectId
    }
    if (this.user && this.user.name) {
      if (item && item.sequence && item.sequence.length > 0) {
        for (let n of item.sequence) {
          this.questions.splice(this.questions.findIndex((itm) => itm === n), 1)
        }
        params.question_cart.question_ids = this.questions
        setTimeout(() => {
          sa.track('ContentRepository_question_Other', {
            screenType: '试题篮',
            buttonName: '删除'
          })
        }, 50)
      } else {
        setTimeout(() => {
          sa.track('ContentRepository_question_Other', {
            screenType: '试题篮',
            buttonName: ' 清空'
          })
        }, 50)
      }
      let { msg } = await updateQuestionCart(params)
      // console.log(msg)
      // this.processCart(msg)
      this.$store.commit('SET_CART', msg)
    } else {
      this.$store.commit('SET_LOGINMODAL', true)
    }

    // if (item && item.val && item.val.length > 0) {
    //   for (let n of item.val) {
    //     this.questions.splice(this.questions.findIndex((itm) => itm === n), 1)
    //   }
    //   params.question_cart.question_ids = this.questions
    // }
    // let { msg } = await updateQuestionCart(params)
    // // console.log(msg)
    // // this.processCart(msg)
    // this.$store.commit('SET_CART', msg)
  }
}
